// extracted by mini-css-extract-plugin
module.exports = {"leagueName":"LeagueName_leagueName__GulQW","flagContainer":"LeagueName_flagContainer__2c4pJ","flag":"LeagueName_flag__16k8n"};